// form_hooks
export const INPUT_CHANGE = 'INPUT_CHANGE';
export const CHECK_FORM_VALIDITY = 'CHECK_FORM_VALIDITY';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
